<template>
  <div class="filters">
    <tl-select
      label="Cost Center"
      labelText="name"
      name="cost_center"
      :options="costCenterList"
      v-model="filterModel.costCenterId"
      @change="(val) => filterModel.costCenterId = val"
    ></tl-select>
    <tl-select
      label="Designation"
      labelText="name"
      name="designation"
      :options="designationList"
      v-model="filterModel.designationId"
      @change="(val) => filterModel.designationId = val"
    ></tl-select>
    <tl-select
      label="Grades"
      labelText="name"
      name="grades"
      :options="gradeList"
      v-model="filterModel.gradeId"
      @change="(val) => filterModel.gradeId = val"
    ></tl-select>
    <tl-select
      label="Department"
      labelText="name"
      name="department"
      :options="departmentList"
      v-model="filterModel.departmentId"
      @change="(val) => filterModel.departmentId = val"
    ></tl-select>
    <tl-select
      label="Bands"
      labelText="name"
      name="bands"
      :options="bandList"
      v-model="filterModel.bandId"
      @change="(val) => filterModel.bandId = val"
    ></tl-select>
    <btn
      text="Apply Filter"
      type="secondary"
      class="btn-filter"
      v-on:click="returnSelectedValue()"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "EmpFilter",
  props: {},
  data() {
    return {
      costCenterList: [],
      designationList: [],
      gradeList: [],
      departmentList: [],
      bandList: [],
      filterModel: {
        bandId: {id:'', name:'All'},
        gradeId: {id:'', name:'All'},
        designationId: {id:'', name:'All'},
        departmentId: {id:'', name:'All'},
        costCenterId: {id:'', name:'All'}
      }
    };
  },
  activated() {
    this.getDesignations();
    this.getGrades();
    this.getBands();
    this.getDepartment();
    this.getCostCenter();
  },
  computed: {
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState("onboard/organization", {
      orgid: state => state.id
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    }
  },
  methods: {
    ...mapActions({
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_businessunits: "onboard/business_units/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll"
    }),
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.gradeList = res.data.payload.data;
          if(this.gradeList.length){
            this.gradeList.splice(0, 0, { id: "", name: "All" });
          }else{
            this.gradeList.push({ id: "", name: "All" });
          }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getBands() {
      try {
        let res = await this.fetch_bands(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.bandList = res.data.payload.data;
          if(this.bandList.length){
            this.bandList.splice(0, 0, { id: "", name: "All" });
          }else{
            this.bandList.push({ id: "", name: "All" });
          }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getDepartment() {
      try {
        let res = await this.fetch_businessunits(this.orgid);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.departmentList = res.data.payload.data;
          if(this.departmentList.length){
            this.departmentList.splice(0, 0, { id: "", name: "All" });
          }else{
            this.departmentList.push({ id: "", name: "All" });
          }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.costCenterList = res.data.payload.data;
          if(this.costCenterList.length){
            this.costCenterList.splice(0, 0, { id: "", name: "All" });
          }else{
            this.costCenterList.push({ id: "", name: "All" });
          }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getDesignations() {
      try {
        let res = await this.fetch_designation(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.designationList = res.data.payload.data;
          if(this.designationList.length){
            this.designationList.splice(0, 0, { id: "", name: "All" });
          }else{
            this.designationList.push({ id: "", name: "All" });
          }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    returnSelectedValue() {
      let Obj = {
        bandId: this.filterModel.bandId.id,
        costCenterId: this.filterModel.costCenterId.id,
        departmentId: this.filterModel.departmentId.id,
        designationId: this.filterModel.designationId.id,
        gradeId: this.filterModel.gradeId.id
      }
      this.$emit("applyFilter", Obj);
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-filter {
  margin-top: 20px;
  padding: 0px;
  min-height: 35px;
}
</style>
